import { useEffect, useRef } from 'react';
import { Button, useToast } from '@chakra-ui/react';
import { useAddCasesDispatch } from './index';
import { clearDraft, loadDraft } from './draft';

/**
 * Dipanggil saat halaman Tambah Kasus dibuka.
 * Kalau ada draft (form yang belum terkirim, mis. karena sesi habis / koneksi putus)
 * untuk caseType ini, form dipulihkan. Kalau tidak, form dikosongkan seperti biasa.
 */
const useCaseDraft = (caseType: string) => {
  const casesDispatch = useAddCasesDispatch();
  const toast = useToast();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const draft = loadDraft(caseType);

    if (!draft) {
      casesDispatch({ type: 'reset_state', data: {} });
      if (caseType !== 'OK') {
        casesDispatch({ type: 'set_case_type', data: { caseType } });
      }
      return;
    }

    casesDispatch({ type: 'restore_draft', data: { state: draft } });

    const toastId = toast({
      position: 'top',
      duration: 10000,
      isClosable: true,
      render: ({ onClose }) => (
        <div
          style={{
            background: '#2B6CB0',
            color: 'white',
            padding: '12px 16px',
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            gap: 12,
          }}
        >
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700 }}>Draft dipulihkan</div>
            <div style={{ fontSize: 13 }}>
              Form kasus yang belum terkirim sebelumnya sudah dimuat kembali.
            </div>
          </div>
          <Button
            size="sm"
            variant="outline"
            color="white"
            _hover={{ background: 'whiteAlpha.300' }}
            onClick={() => {
              clearDraft();
              casesDispatch({ type: 'reset_state', data: {} });
              if (caseType !== 'OK') {
                casesDispatch({ type: 'set_case_type', data: { caseType } });
              }
              onClose();
            }}
          >
            Buang draft
          </Button>
        </div>
      ),
    });

    return () => {
      if (toastId) toast.close(toastId);
    };
  }, [caseType, casesDispatch, toast]);
};

export default useCaseDraft;
